import React from "react";
import { CustomCheckbox, SelectProductList } from "../../styled";
import { renderProductInfo } from "../../../../common/function/shopping";

const SelectProducts = ({ products, selectedProducts, onToggle }) => {
  return (
    <>
      <span className="info">취소할 상품을 확인해주세요</span>
      <SelectProductList>
        {products.map((product) => (
          <li key={product.id}>
            {/* <CustomCheckbox>
              <input
                type="checkbox"
                checked={selectedProducts.includes(product.id)}
                onChange={() => onToggle(product.id)}
              />
              <span></span>
            </CustomCheckbox> */}
            <img src={imgHandler(product.media)} alt={product.productName} />
            {renderProductInfo(product)}
          </li>
        ))}
      </SelectProductList>
    </>
  );
};

export default SelectProducts;
